import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/news";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-accent-950 text-background-100">
      <div className="mx-auto max-w-site px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">看瓜爆料</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              看瓜爆料最新实时更新，今日热点瓜料与新鲜爆料速递不停歇。随时刷新随时有料，
              <br className="hidden sm:block" />
              满足你第一时间追瓜、吃瓜、看内幕的需求。
            </p>
            <p className="mt-4 flex items-center gap-1.5 text-xs text-accent-300">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
              编辑部持续在线更新
            </p>
          </div>

          <nav aria-label="主题栏目">
            <h2 className="font-heading text-sm font-bold tracking-wider text-background-50">
              主题栏目
            </h2>
            <ul className="mt-4 space-y-2.5">
              {categories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-300"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="站内导航">
            <h2 className="font-heading text-sm font-bold tracking-wider text-background-50">
              站内导航
            </h2>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-200/80 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/#today-feed" className="text-sm text-background-200/80 transition-colors hover:text-accent-300">
                  今日速递
                </Link>
              </li>
              <li>
                <Link to="/#hot-topic" className="text-sm text-background-200/80 transition-colors hover:text-accent-300">
                  实时热榜
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-background-200/80 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/80 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold tracking-wider text-background-50">
              联系我们
            </h2>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-300" aria-hidden="true"></i>
                读者与线索：{siteInfo.contactEmail}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-briefcase-line text-base text-accent-300" aria-hidden="true"></i>
                商务与合作：{siteInfo.prEmail}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-1 text-base text-accent-300" aria-hidden="true"></i>
                热点时段全天候轮值跟进
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name} · {siteInfo.slogan}</p>
          <p>页面内容综合公开信息整理，仅供参考与讨论。</p>
        </div>
      </div>
    </footer>
  );
}